import API from '@services/API';

const OrigemService = {
	listar: async () => await API.list(`origem`),
}

export default OrigemService;